import * as yup from "yup";

interface User {
  id: number;
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
}

type Record = {
  user: User;
  content: string;
  content_type: number;
  content_id: number;
};

export interface ConsoleListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Record[];
}

export interface CustomerModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  modalType?: string;
  userData?: Console;
}

export interface CustomerAddRequest {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id?: string | null | number;
  assingPersonName?: string;
}

export interface CustomerAddResponse {
  name: string;
  description: string;
  date: Date;
  person_who_assign_id: User;
  status: number;
}

export interface CustomerUpdateRequest {
  id?: string;
  name?: string;
  description?: string;
  date?: string;
  person_who_assign_id?: number;
  person_who_complete_id?: number;
}

export interface CustomerUpdateResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export interface CustomerDeleteRequest {
  id: string;
}

export interface CustomerDeleteResponse {
  email: string;
  fullname: string;
  username: string;
  date_of_start: Date;
  salary_net: number;
  salary_gross: number;
  phone_number: string;
  status: number;
}

export const customerAddSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const customerUpdateSchema = yup.object().shape({
  name: yup.string().required("İş adı boş bırakılamaz"),
  description: yup.string().required("Açıklama boş bırakılamaz"),
  date: yup.date().required("İş tarihi boş bırakılamaz"),
});

export const filtersTypes = [
  { key: "Hepsi", value: 0 },
  { key: "Müşteri", value: 1 },
  { key: "Bakım", value: 2 },
  { key: "Gelir", value: 3 },
  { key: "Gider", value: 4 },
];
